import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const DroneIframeModal = ({
  iframeRef,
  show,
  title,
  src,
  loading,
  onLoad,
  onHide,
}) => (
  <Modal show={show} onHide={onHide} size="xl" centered>
    <Modal.Header closeButton style={{ padding: '6px 12px' }}>
      <Modal.Title style={{ fontSize: 16, lineHeight: '20px' }}>
        {title || 'Drone Managment'}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ height: '80vh', padding: 0 }}>
      {loading || !src ? (
        <div className="d-flex align-items-center justify-content-center h-100">
          <Spinner animation="border" />
        </div>
      ) : (
        <iframe
          ref={iframeRef}
          title={title || 'Drone Managment'}
          src={src}
          onLoad={onLoad}
          style={{ border: 0, width: '100%', height: '100%' }}
          allow="fullscreen"
        />
      )}
    </Modal.Body>
  </Modal>
);

export default DroneIframeModal;
